var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "brick-settings-popup",
    {
      attrs: {
        resources: {
          deletePromptTitle: _vm.resource("JourneyBuilder_ABTest_Delete_Title"),
          deletePromptBody: _vm.resource("JourneyBuilder_ABTest_Delete_Body"),
          brickTitle:
            _vm.resource("JourneyComposer_BrickSettingsABTest_Title") +
            " " +
            _vm.resource("JourneyComposer_BrickSettingsBase_Title")
        },
        brick: _vm.brick,
        name: _vm.newName,
        invalid: _vm.$v.$invalid
      },
      on: {
        "update:name": function($event) {
          _vm.newName = $event
        },
        save: function($event) {
          return _vm.saveSettings()
        },
        delete: function($event) {
          return _vm.$emit("delete")
        },
        hidden: function($event) {
          return _vm.$emit("hidden")
        },
        "display-errors": function($event) {
          return _vm.displayErrors()
        }
      }
    },
    [
      _c("settings-item", {
        attrs: { icon: "fas fa-columns" },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "ab-attributes" }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.resource(
                            "JourneyComposer_ABTest_Attributes_DisplayName"
                          )
                        ) +
                        "\n            "
                    )
                  ]
                )
              ]
            },
            proxy: true
          },
          {
            key: "input",
            fn: function() {
              return [
                _c("v-select", {
                  staticClass: "form-control",
                  attrs: {
                    label: "label",
                    inputId: "ab-attributes",
                    multiple: "",
                    clearable: "",
                    closeOnSelect: false,
                    options: _vm.selectableAttributes,
                    disabled: !_vm.canWrite
                  },
                  model: {
                    value: _vm.settings.attributes,
                    callback: function($$v) {
                      _vm.$set(_vm.settings, "attributes", $$v)
                    },
                    expression: "settings.attributes"
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row form-group" },
        [
          _c("id-dispenser", {
            attrs: { elements: _vm.settings.routes },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var idsPerElement = ref.idsPerElement
                  return _vm._l(_vm.settings.routes, function(route, index) {
                    return _c(
                      "div",
                      {
                        key: idsPerElement.get(route),
                        staticClass: "col-12 ab-route"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row form-group" },
                          [
                            _c("a-b-test-route", {
                              staticClass: "col-12",
                              attrs: {
                                color: route.color,
                                percentage: route.percentage,
                                description: route.description
                              },
                              on: {
                                "update:color": function($event) {
                                  return _vm.$set(route, "color", $event)
                                },
                                "update:percentage": function($event) {
                                  return _vm.$set(route, "percentage", $event)
                                },
                                "update:description": function($event) {
                                  return _vm.$set(route, "description", $event)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "offset-8 col-4" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-danger btn-icon-left w-100",
                                  attrs: { disabled: !_vm.canWrite },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.removeRoute(route)
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-minus" }),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.resource(
                                          "JourneyComposer_ABTest_DeleteRoute"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            index !== _vm.settings.routes.length - 1
                              ? _c("div", { staticClass: "col-12" }, [_c("hr")])
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  })
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("div", { staticClass: "offset-8 col-4" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary btn-icon-left w-100",
                attrs: { disabled: !_vm.canWrite },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.addRoute($event)
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.resource("JourneyComposer_ABTest_AddRoute")) +
                    "\n            "
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.$v.$invalid && _vm.$v.$dirty
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "offset-4 col-8" },
              [
                !_vm.$v.routesTotalPercentage.isHundredPercent
                  ? _c("error-message", {
                      attrs: { message: _vm.isHundredPercentValidationMessage }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }